import React from "react";
import { Link } from "react-router-dom";
import { Users } from "lucide-react";
import { useBranding } from "@/lib/branding";
import Footer from "@/components/Footer";

// Minimal chrome for the class-agent record view: brand header + a single "Directory"
// nav item, and the same constrained content container as the admin Layout.
export default function AgentDetailLayout({ children }) {
  const b = useBranding();
  return (
    <div className="min-h-screen flex bg-background">
      <aside className="w-64 shrink-0 bg-secondary text-white flex-col hidden md:flex sticky top-0 h-screen">
        <div className="px-6 py-6 border-b border-white/10 flex items-center gap-3">
          <a href={b.university_url} target="_blank" rel="noopener noreferrer" title={`Visit ${b.university_name}`} className="h-11 w-11 rounded-full bg-white flex items-center justify-center p-0.5 shrink-0 overflow-hidden transition-transform hover:scale-105">
            {b.logo_primary ? <img src={b.logo_primary} alt="seal" className="h-full w-full object-contain" /> : <span className="font-serif text-secondary">{(b.university_name || "U").slice(0, 1)}</span>}
          </a>
          <div>
            <div className="font-serif text-lg leading-none tracking-tight">{b.university_name}</div>
            <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-accent mt-1">{b.short_name}</div>
          </div>
        </div>
        <nav className="flex-1 py-4 px-3 space-y-1">
          <Link to="/experience/directory" data-testid="agent-nav-directory" className="flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium bg-accent text-accent-foreground font-semibold">
            <Users className="h-4 w-4" /> Directory
          </Link>
        </nav>
      </aside>
      <main className="flex-1 min-w-0 relative bg-slate-300/60 min-h-screen">
        <div className="relative z-10">
          <div className="max-w-7xl mx-auto px-5 sm:px-8 py-8">{children}</div>
          <Footer />
        </div>
      </main>
    </div>
  );
}
